import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

const isActive = b => {
    if (b.enabled === false) return false
    const now = new Date()
    if (b.activeFrom && new Date(b.activeFrom) > now) return false
    if (b.activeTo   && new Date(b.activeTo)   < now) return false
    return true
}

const shuffle = arr => {
    const a = [...arr]
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
    }
    return a
}

define('FeaturedBusinesses', () => {
    const root = h('section', { className: 'featured-biz' })

    fetch(`/data/businesses.json?t=${Date.now()}`)
        .then(r => r.json())
        .then(data => {
            const gold = (data.items || []).filter(b => isActive(b) && b.plan === 'oro')
            if (!gold.length) return

            const items = shuffle(gold).slice(0, 8)

            const track = h('div', { className: 'featured-biz__track' })
            items.forEach(item => track.appendChild(c('BusinessCard', item)))

            let dragging = false, startX = 0, scrollLeft = 0
            track.addEventListener('mousedown', e => {
                dragging = true
                startX = e.clientX
                scrollLeft = track.scrollLeft
                track.style.scrollBehavior = 'auto'
                track.style.cursor = 'grabbing'
            })
            track.addEventListener('mousemove', e => {
                if (!dragging) return
                e.preventDefault()
                track.scrollLeft = scrollLeft - (e.clientX - startX)
            })
            const endDrag = () => {
                if (!dragging) return
                dragging = false
                track.style.cursor = ''
                track.style.scrollBehavior = ''
            }
            track.addEventListener('mouseup', endDrag)
            track.addEventListener('mouseleave', endDrag)

            const prev = h('button', { className: 'carousel-arrow carousel-arrow--prev', type: 'button' }, '‹')
            const next = h('button', { className: 'carousel-arrow carousel-arrow--next', type: 'button' }, '›')

            prev.addEventListener('click', () => {
                track.scrollBy({ left: -track.offsetWidth * 0.8, behavior: 'smooth' })
            })
            next.addEventListener('click', () => {
                track.scrollBy({ left: track.offsetWidth * 0.8, behavior: 'smooth' })
            })

            const wrapper = h('div', { className: 'carousel-wrap' }, prev, track, next)

            root.appendChild(
                h('div', { className: 'featured-biz__inner' },
                    h('div', { className: 'featured-biz__header' },
                        h('h2', { className: 'featured-biz__title' }, 'Negocios destacados'),
                        h('a',  { className: 'featured-biz__see-all', href: '/directorio' }, 'Ver directorio →')
                    ),
                    wrapper
                )
            )
        })
        .catch(() => {})

    return root
})
